import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";

const noteTitleOptions = [
  "OPD Card",
  "Sleep Study Form",
  "Consent Form",
  "ใบคำสั่งตรวจการนอน",
  "แบบประเมินการนอน",
  "Stop-Bang",
  "Visit-Slip",
  "Medical Certificate",
  "CPAP Trial",
  "CPAP Follow Up",
  "F/U",
];

const customTitleValue = "__custom_title__";

const PatientNoteForm = (props) => {
  const noteData = {
    title: props.note ? props.note.title : "",
    detail: props.note ? props.note.detail : "",
    filename: props.note ? props.note.filename : [],
    hn: props.note ? props.note.hn : props.hn,
    createBy: props.note ? props.note.createBy : props.createBy,
    updateAt: props.note ? props.note.updateAt : null,
    createAt: props.note ? props.note.createAt : new Date(),
    error: "",
  };
  const { currentUser } = useAuth();

  const [isHide, setIsHide] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileNames, setFilenames] = useState([]);
  const [title, setTitle] = useState("");
  const [customTitle, setCustomTitle] = useState("");
  const detailRef = useRef("");

  const onFilesChange = (e) => {
    let files = [];
    for (let i = 0; i < e.target.files.length; i++) {
      const f = e.target.files[i];
      setSelectedFiles((prevState) => [...prevState, f]);
      setFilenames((prevState) => [...prevState, f.name]);
    }
  };

  // const onHNChange = (e) => {
  //   setNewNote({ hn: e.target.value });
  // };

  // const onCreateByChange = (e) => {
  //   setNewNote( { createBy: e.target.value });
  // };

  // const onUpdateAtChange = (e) => {
  //   setNewNote({ updateAt: e.target.value });
  // };

  // const onCreateAtChange = (e) => {
  //   setNewNote({ createAt: e.target.value });
  // };

  const onSubmit = (e) => {
    e.preventDefault();
    props.onSubmit(
      {
        title:
          title === customTitleValue ? customTitle.trim() : title,
        detail: detailRef.current.value,
        filename: noteData.filename,
        hn: noteData.hn,
        createBy: noteData.createBy,
        updateAt: noteData.updateAt,
        createAt: noteData.createAt,
      },
      selectedFiles,
    );
    detailRef.current.value = "";
    setTitle("");
    setCustomTitle("");
    setFilenames([]);
    setIsHide(true);
    setSelectedFiles([]);
  };

  const onCancel = () => {
    detailRef.current.value = "";
    setTitle("");
    setCustomTitle("");
    setIsHide(true);
    setFilenames([]);
    setSelectedFiles([]);
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#fff3cd",
          color: "#856404",
          padding: "1rem",
          border: "1px solid #ffeeba",
          borderRadius: "4px",
          margin: "1rem 0",
        }}
      >
        <strong>Note:</strong> HEIC images are not supported. Please convert
        {" your image to JPG using this free tool -----> "}{" "}
        <a
          href="https://www.canva.com/features/heic-to-jpg-converter/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Canva HEIC to JPG Converter
        </a>
        .
      </div>
      <div className="col-lg-12 mb-5">
        <b>Add Note</b>

        <div className="col-xl-9 col-lg-12 ">
          {[
            "super_admin",
            "admin",
            "sale",
            "accountant",
            "staff",
            "sleep_technician",
          ].includes(currentUser.roles[0]) && (
            <>
              <div className="form-group mt-3 mb-0">
                <label className="mb-1" htmlFor="patient-note-title">
                  Title
                </label>
                <select
                  id="patient-note-title"
                  className="form-control"
                  value={title}
                  onFocus={() => setIsHide(false)}
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setIsHide(false);
                  }}
                >
                  <option value="" disabled>
                    Select title...
                  </option>
                  {noteTitleOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                  <option value={customTitleValue}>
                    Other title (type manually)
                  </option>
                </select>
              </div>

              {title === customTitleValue && (
                <div className="form-group mt-3 mb-0">
                  <label className="mb-1" htmlFor="patient-note-custom-title">
                    Custom title
                  </label>
                  <input
                    id="patient-note-custom-title"
                    type="text"
                    className="form-control"
                    placeholder="Type title..."
                    value={customTitle}
                    onChange={(e) => setCustomTitle(e.target.value)}
                  />
                </div>
              )}
            </>
          )}
          {!isHide ? (
            <>
              <textarea
                className="form-control mt-3 mb-3"
                id="val-suggestions"
                name="val-suggestions"
                rows="5"
                placeholder="Add note here..."
                ref={detailRef}
              ></textarea>
              <div className="basic-form custom_file_input">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">Upload</span>
                  </div>
                  <div className="custom-file">
                    <input
                      type="file"
                      multiple
                      className="custom-file-input"
                      onChange={onFilesChange}
                    />
                    <label className="custom-file-label">
                      {fileNames + " "}
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group row ml-1">
                <Button className="sm " onClick={onSubmit}>
                  Save
                </Button>
                <Button className="sm ml-2" variant="light" onClick={onCancel}>
                  Cancel
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default PatientNoteForm;
